var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLassoAnnotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lasso selection") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lasso-selection",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "Path",
    stroke: "#BABABA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9200215,5.20050274 C22.7422808,7.79423331 22.7422808,11.9995035 18.9200215,14.593244 C15.0977622,17.1869746 8.90062147,17.1869746 5.07841219,14.593244 C1.25615292,11.9995135 1.25615292,7.79424331 5.07841219,5.20050274 C8.90067146,2.60677217 15.0978122,2.60677217 18.9200215,5.20050274",
    strokeWidth: 1.49992515,
    transform: "translate(11.999217, 9.896873) rotate(-14.928464) translate(-11.999217, -9.896873) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7110001,16.3150001 C9.54400004,17.4260001 4.30200002,16.4030001 4.30200002,12.9560001",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.048,14.1050001 C10.048,16.3230001 8.89900004,19.8510001 4.30200002,21.0000001",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.30200002,12.9560001 C4.30200002,9.50900004 10.048,9.50900004 10.048,14.1050001",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24.0000001 0 24.0000001 24.0000001 0 24.0000001"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLassoAnnotation);
export default __webpack_public_path__ + "static/media/LassoAnnotation.c53651debe68141f2a9d9fbed32fdcb7.svg";
export { ForwardRef as ReactComponent };